import { getAuthAxios } from "@artprov/design-system";

const paths = {
  getAll: "conceptoGasto"
};

export const getConceptoGasto = async () => {
  const response = await getAuthAxios("default").get(paths.getAll);
  return response;
};